import React from 'react';
import type { Entity } from 'src/web/collections/types';

import { createGRN } from 'logic/permissions/GRN';
import useShowRouteFromGRN from 'routing/hooks/useShowRouteFromGRN';
import useHasEntityPermissionByGRN from 'hooks/useHasEntityPermissionByGRN';
import { Link } from 'components/common/router';

type Props = Pick<Entity, 'id' | 'name' | 'type'>;

const TitleCell = ({ id, name, type }: Props) => {
  const grn = createGRN(type, id);
  const hasReadPermission = useHasEntityPermissionByGRN(grn, 'read');

  const entityRoute = useShowRouteFromGRN(grn);

  if (hasReadPermission) {
    return <Link to={entityRoute}>{name}</Link>;
  }

  return <>{name}</>;
};
export default TitleCell;
